import { Select, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IFormInputSpec, IAggregateFunction } from 'pages/revisions-module/template-editor/editors/form/types';

export const AGG_FUNC_OPTIONS: { value: IAggregateFunction; label: string }[] = [
  { value: 'count', label: 'počet' },
  { value: 'count-selected', label: 'počet výskytov zvolenej hodnoty' },
  { value: 'sum', label: 'súčet' },
  { value: 'min', label: 'minimum' },
  { value: 'max', label: 'maximum' },
  { value: 'concat', label: 'zreťazenie' },
  { value: 'concat-unique', label: 'zreťazenie unikátnych hodnôt' },
  { value: 'frequency-expression', label: 'výraz početností' },
  { value: 'numberOfUniqueValues', label: 'počet unikátnych hodnôt' },
  { value: 'numberOfNonEmptyValues', label: 'počet neprázdnych hodnôt' },
  { value: 'numberOfEmptyValues', label: 'počet prázdnych hodnôt' },
];

/**
 * Shared sub-form for aggregation function selection used by aggregator input types.
 */
export function AggFuncSubForm({
  form,
  selectedValueOptions,
}: {
  form: UseFormReturnType<IFormInputSpec>;
  selectedValueOptions?: string[];
}) {
  const aggFunc = (form.values as { aggFunc?: string }).aggFunc;
  const selectedValueData = (selectedValueOptions ?? []).map((option) => ({ value: option, label: option }));

  return (
    <>
      <Select required size="sm" label="Agregačná funkcia" data={AGG_FUNC_OPTIONS} {...form.getInputProps('aggFunc')} />
      {aggFunc === 'count-selected' &&
        (selectedValueData.length > 0 ? (
          <Select
            required
            searchable
            size="sm"
            label="Počítaná hodnota"
            data={selectedValueData}
            nothingFound="Žiadna možnosť"
            {...form.getInputProps('selectedValue')}
          />
        ) : (
          <TextInput
            required
            size="sm"
            label="Počítaná hodnota"
            placeholder="Zadajte hodnotu"
            {...form.getInputProps('selectedValue')}
          />
        ))}
      {(aggFunc === 'concat' || aggFunc === 'concat-unique') && (
        <TextInput size="sm" label="Oddeľovač" placeholder="Bez oddeľovača" {...form.getInputProps('separator')} />
      )}
    </>
  );
}
